import { FaTimes } from "react-icons/fa";

const Task = ({ task, onDelete, onToggle }) => {
  return (
    <div className={`task ${task.taskImportant === "1" && "reminder"}`} onDoubleClick={() => onToggle(task.taskID)}>
      <h3>
        {task.taskTitle} <FaTimes style={{ color: "red", cursor: "pointer" }} onClick={() => onDelete(task.taskID)} />
      </h3>
      <p>{task.taskText}</p>
    </div>
  );
};

export default Task;
